var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 328,
    viewBox: "0 0 324 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 321,
    height: 325,
    fill: "url(#paint0_linear_908_1737)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.974 160.935C262.78 156.765 264.599 152.915 264.599 149.591C264.599 146.267 262.78 142.417 257.974 138.248C253.181 134.091 245.932 130.102 236.507 126.644C217.699 119.744 191.358 115.37 162 115.37C132.641 115.37 106.3 119.744 87.4922 126.644C78.0669 130.102 70.8181 134.091 66.0254 138.248C61.2186 142.417 59.4 146.267 59.4 149.591C59.4 152.915 61.2186 156.765 66.0254 160.935C70.8181 165.092 78.0669 169.081 87.4922 172.539C106.3 179.438 132.641 183.813 162 183.813C191.358 183.813 217.699 179.438 236.507 172.539C245.932 169.081 253.181 165.092 257.974 160.935ZM162 189.213C221.646 189.213 269.999 171.474 269.999 149.591C269.999 127.709 221.646 109.97 162 109.97C102.353 109.97 54 127.709 54 149.591C54 171.474 102.353 189.213 162 189.213Z",
    fill: "url(#paint1_linear_908_1737)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.974 189.75C262.78 185.581 264.599 181.731 264.599 178.407C264.599 175.083 262.78 171.233 257.974 167.064C253.181 162.906 245.932 158.917 236.507 155.46C217.699 148.56 191.358 144.185 162 144.185C132.641 144.185 106.3 148.56 87.4922 155.46C78.0669 158.917 70.8181 162.906 66.0254 167.064C61.2186 171.233 59.4 175.083 59.4 178.407C59.4 181.731 61.2186 185.581 66.0254 189.75C70.8181 193.907 78.0669 197.896 87.4922 201.354C106.3 208.254 132.641 212.628 162 212.628C191.358 212.628 217.699 208.254 236.507 201.354C245.932 197.896 253.181 193.907 257.974 189.75ZM162 218.028C221.646 218.028 269.999 200.289 269.999 178.407C269.999 156.524 221.646 138.785 162 138.785C102.353 138.785 54 156.524 54 178.407C54 200.289 102.353 218.028 162 218.028Z",
    fill: "url(#paint2_linear_908_1737)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.403 99.1124C231.197 92.862 228.775 89.3628 225.9 87.7021C223.025 86.0414 218.785 85.6916 212.772 87.7722C206.777 89.8467 199.7 94.1335 191.994 100.572C176.617 113.419 159.66 134.057 144.98 159.497C130.301 184.937 120.916 209.95 117.485 229.697C115.765 239.594 115.593 247.87 116.795 254.101C118 260.352 120.423 263.851 123.298 265.512C126.173 267.172 130.413 267.522 136.426 265.441C142.42 263.367 149.498 259.08 157.204 252.642C172.58 239.794 189.538 219.156 204.217 193.717C218.897 168.277 228.282 143.264 231.713 123.516C233.433 113.62 233.605 105.344 232.403 99.1124ZM208.893 196.418C238.717 144.734 247.539 93.9662 228.599 83.025C209.658 72.0837 170.128 105.112 140.304 156.796C110.481 208.48 101.659 259.248 120.599 270.189C139.539 281.13 179.07 248.102 208.893 196.418Z",
    fill: "url(#paint3_linear_908_1737)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M212.809 240.192C218.823 242.273 223.064 241.924 225.94 240.264C228.815 238.604 231.238 235.106 232.443 228.857C233.644 222.627 233.471 214.352 231.75 204.458C228.315 184.714 218.926 159.705 204.24 134.269C189.555 108.833 172.591 88.1968 157.21 75.3503C149.501 68.9123 142.422 64.6255 136.426 62.5508C130.412 60.4699 126.171 60.8191 123.295 62.4792C120.42 64.1392 117.997 67.6373 116.792 73.8863C115.591 80.1165 115.764 88.3909 117.485 98.2854C120.92 118.029 130.309 143.038 144.995 168.474C159.68 193.91 176.644 214.546 192.025 227.393C199.733 233.831 206.813 238.118 212.809 240.192ZM140.318 171.174C170.154 222.851 209.697 255.877 228.64 244.941C247.582 234.004 238.752 183.246 208.917 131.569C179.081 79.8923 139.538 46.8659 120.595 57.8026C101.652 68.7393 110.483 119.498 140.318 171.174Z",
    fill: "url(#paint4_linear_908_1737)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.974 175.342C262.78 171.173 264.599 167.323 264.599 163.999C264.599 160.674 262.78 156.825 257.974 152.655C253.181 148.498 245.932 144.509 236.507 141.051C217.699 134.152 191.358 129.777 162 129.777C132.641 129.777 106.3 134.152 87.4922 141.051C78.0669 144.509 70.8181 148.498 66.0254 152.655C61.2186 156.825 59.4 160.674 59.4 163.999C59.4 167.323 61.2186 171.173 66.0254 175.342C70.8181 179.499 78.0669 183.488 87.4922 186.946C106.3 193.846 132.641 198.22 162 198.22C191.358 198.22 217.699 193.846 236.507 186.946C245.932 183.488 253.181 179.499 257.974 175.342ZM162 203.62C221.646 203.62 269.999 185.881 269.999 163.999C269.999 142.116 221.646 124.377 162 124.377C102.353 124.377 54 142.116 54 163.999C54 185.881 102.353 203.62 162 203.62Z",
    fill: "url(#paint5_linear_908_1737)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.803 86.5049C218.598 80.2546 216.175 76.7554 213.3 75.0947C210.425 73.434 206.185 73.0841 200.172 75.1648C194.178 77.2392 187.1 81.5261 179.394 87.9645C164.018 100.812 147.06 121.45 132.381 146.89C117.701 172.329 108.317 197.342 104.885 217.09C103.165 226.986 102.993 235.262 104.195 241.494C105.401 247.744 107.824 251.243 110.698 252.904C113.573 254.565 117.813 254.915 123.826 252.834C129.821 250.76 136.898 246.473 144.604 240.034C159.981 227.187 176.938 206.549 191.618 181.109C206.297 155.669 215.682 130.657 219.114 110.909C220.833 101.013 221.005 92.7366 219.803 86.5049ZM196.294 183.81C226.117 132.126 234.939 81.3588 215.999 70.4175C197.059 59.4763 157.528 92.5047 127.705 144.189C97.8816 195.872 89.0592 246.64 108 257.581C126.94 268.523 166.47 235.494 196.294 183.81Z",
    fill: "url(#paint6_linear_908_1737)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.204 79.2999C205.998 73.0495 203.575 69.5503 200.701 67.8896C197.826 66.2289 193.586 65.8791 187.573 67.9597C181.578 70.0342 174.501 74.321 166.795 80.7594C151.418 93.6067 134.461 114.245 119.781 139.685C105.102 165.124 95.717 190.137 92.2853 209.885C90.5655 219.781 90.3938 228.057 91.5956 234.289C92.8011 240.539 95.2239 244.038 98.0988 245.699C100.974 247.36 105.214 247.71 111.226 245.629C117.221 243.555 124.299 239.268 132.005 232.829C147.381 219.982 164.339 199.344 179.018 173.904C193.698 148.464 203.082 123.451 206.514 103.704C208.234 93.8076 208.406 85.5315 207.204 79.2999ZM183.694 176.605C213.517 124.921 222.34 74.1537 203.399 63.2125C184.459 52.2712 144.928 85.2997 115.105 136.984C85.282 188.667 76.4596 239.435 95.3999 250.376C114.34 261.317 153.871 228.289 183.694 176.605Z",
    fill: "url(#paint7_linear_908_1737)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.173 252.835C206.186 254.915 210.426 254.566 213.301 252.905C216.176 251.244 218.599 247.745 219.804 241.495C221.006 235.263 220.834 226.987 219.115 217.091C215.683 197.343 206.298 172.33 191.619 146.89C176.939 121.451 159.982 100.813 144.605 87.9652C136.899 81.5268 129.822 77.2399 123.827 75.1655C117.814 73.0848 113.574 73.4347 110.699 75.0954C107.825 76.7561 105.402 80.2553 104.196 86.5056C102.994 92.7373 103.166 101.013 104.886 110.91C108.318 130.657 117.702 155.67 132.382 181.11C147.061 206.55 164.019 227.188 179.395 240.035C187.101 246.473 194.179 250.76 200.173 252.835ZM127.706 183.811C157.529 235.495 197.06 268.523 216 257.582C234.94 246.641 226.118 195.873 196.295 144.189C166.471 92.5055 126.941 59.477 108 70.4182C89.0602 81.3595 97.8825 132.127 127.706 183.811Z",
    fill: "url(#paint8_linear_908_1737)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.574 260.038C193.587 262.119 197.827 261.769 200.702 260.108C203.576 258.447 205.999 254.948 207.205 248.698C208.407 242.466 208.235 234.19 206.515 224.294C203.083 204.546 193.699 179.533 179.019 154.094C164.34 128.654 147.382 108.016 132.006 95.1683C124.3 88.7299 117.222 84.4431 111.227 82.3686C105.215 80.288 100.975 80.6378 98.0997 82.2985C95.2249 83.9592 92.802 87.4584 91.5966 93.7088C90.3947 99.9404 90.5665 108.216 92.2863 118.113C95.718 137.86 105.103 162.873 119.782 188.313C134.462 213.753 151.419 234.391 166.796 247.238C174.502 253.677 181.579 257.963 187.574 260.038ZM115.106 191.014C144.929 242.698 184.46 275.726 203.4 264.785C222.341 253.844 213.518 203.076 183.695 151.392C153.872 99.7086 114.341 66.6802 95.4009 77.6214C76.4606 88.5626 85.2829 139.33 115.106 191.014Z",
    fill: "url(#paint9_linear_908_1737)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.893 141.657L187.784 163.998L174.893 186.338L149.111 186.338L136.22 163.998L149.111 141.657L174.893 141.657Z",
    fill: "#3AEFEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.45 138.956L190.899 163.998L176.45 189.038L147.551 189.038L133.102 163.996L147.551 138.956L176.45 138.956ZM150.668 144.357L139.335 163.998L150.668 183.637L173.333 183.637L184.666 163.996L173.333 144.357L150.668 144.357Z",
    fill: "url(#paint10_linear_908_1737)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.673 154.163L173.347 163.995L167.673 173.828L156.325 173.828L150.651 163.995L156.325 154.163L167.673 154.163Z",
    fill: "url(#paint11_linear_908_1737)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 321,
    height: 325,
    stroke: "#D3DEFB",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_1737",
    x1: 397.984,
    y1: 0.0000159798,
    x2: 120.334,
    y2: 312.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_908_1737",
    x1: 54,
    y1: 182.177,
    x2: 268.303,
    y2: 144.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_908_1737",
    x1: 54,
    y1: 210.993,
    x2: 268.303,
    y2: 173.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_908_1737",
    x1: 148.804,
    y1: 286.482,
    x2: 223.589,
    y2: 82.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_908_1737",
    x1: 92.3867,
    y1: 74.0889,
    x2: 232.035,
    y2: 241.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_908_1737",
    x1: 54,
    y1: 196.585,
    x2: 268.303,
    y2: 159.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_908_1737",
    x1: 136.204,
    y1: 273.874,
    x2: 210.989,
    y2: 69.4758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_908_1737",
    x1: 123.605,
    y1: 266.669,
    x2: 198.39,
    y2: 62.2708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_908_1737",
    x1: 79.7957,
    y1: 86.7113,
    x2: 219.47,
    y2: 253.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_908_1737",
    x1: 67.1961,
    y1: 93.9144,
    x2: 206.87,
    y2: 260.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_908_1737",
    x1: 128.443,
    y1: 172.071,
    x2: 174.053,
    y2: 195.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_908_1737",
    x1: 148.822,
    y1: 167.166,
    x2: 166.732,
    y2: 176.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReact);
export default __webpack_public_path__ + "static/media/react.f9cd3d8dd2f66d61a6d0e522f9fa9eab.svg";
export { ForwardRef as ReactComponent };